module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"embedded_hscmap":"Embedded hscMap"},"ja":{"embedded_hscmap":"埋め込みスニペット"}}')
  delete Component.options._Ctor
}
